// src/services/rbac.service.js
import { env } from "../config/env";
import { createClient } from "./http";

// RBAC service base client
const rbacApi = createClient(env.RBAC_BASE_URL || env.AUTH_BASE_URL);

const BASE = "/api/admin/employees/rbac";

function unwrapArray(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.data?.data)) return res.data.data;
  if (Array.isArray(res?.roles)) return res.roles;
  if (Array.isArray(res?.data?.roles)) return res.data.roles;
  if (Array.isArray(res?.permissions)) return res.permissions;
  if (Array.isArray(res?.data?.permissions)) return res.data.permissions;
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.data?.items)) return res.data.items;
  return [];
}

function unwrapObject(res) {
  if (res?.data && !Array.isArray(res.data)) return res.data;
  return res || null;
}

export const rbacService = {
  async listRoles({ target } = {}) {
    const res = await rbacApi.get(`${BASE}/roles`, {
      params: target ? { target } : undefined,
    });

    return unwrapArray(res);
  },

  async getRole(id) {
    const res = await rbacApi.get(`${BASE}/roles/${id}`);
    return unwrapObject(res);
  },

  async createRole(payload) {
    const res = await rbacApi.post(`${BASE}/roles`, payload);
    return unwrapObject(res);
  },

  async updateRole(id, payload) {
    const res = await rbacApi.put(`${BASE}/roles/${id}`, payload);
    return unwrapObject(res);
  },

  async deleteRole(id) {
    return await rbacApi.del(`${BASE}/roles/${id}`);
  },

  async listPermissions({ target } = {}) {
    const res = await rbacApi.get(`${BASE}/permissions`, {
      params: target ? { target } : undefined,
    });

    return unwrapArray(res);
  },

  async createPermission(payload) {
    return await rbacApi.post(`${BASE}/permissions`, payload);
  },

  async deletePermission(id) {
    return await rbacApi.del(`${BASE}/permissions/${id}`);
  },
};